import React, { FC, ReactNode } from 'react';
import s from './GroupSizeSnippet.module.scss';

type GroupSizeSnippetProps = {
  children: ReactNode;
};

const GroupSizeSnippet: FC<GroupSizeSnippetProps> = ({
  children,
}) => (
  <div className={s.root}>
    <div className={s.content}>
      {children}
    </div>
  </div>
);
export default GroupSizeSnippet;
